// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__gYg8Z","footer":"ModalCreateQualiphyProcedure_footer__32EH8","additionData":"ModalCreateQualiphyProcedure_additionData__24iKK"};